import { validateUserInfo } from '@yesplz/core-redux/ducks/admin/auth';
import React, { createContext, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const UserContext = createContext({});

export const useUser = () => {
  return useContext(UserContext);
}

export default function UserProvider({ children }) {
  const { userInfo, isLoading } = useSelector(({ AdminAuth }) => ({
    userInfo: AdminAuth.userInfo,
    isLoading: AdminAuth.isLoadingUserInfo,
  }));
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(validateUserInfo());
  }, []);

  return (
    <UserContext.Provider value={{
      userInfo, isLoading,
    }}>
      {children}
    </UserContext.Provider>
  );
}
